<div
  class="overflow-hidden border border-slate-200 bg-white shadow-lg"
  [class.w-[min(22rem,calc(100vw-2rem))]]="!sheetMode"
  [class.rounded-2xl]="!sheetMode"
  [class.w-full]="sheetMode"
  [class.rounded-t-3xl]="sheetMode"
  [class.max-h-[85vh]]="sheetMode"
  [class.overflow-y-auto]="sheetMode">
  <div class="flex items-start gap-3 px-4 pt-4 pb-3">
    <span
      class="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-full bg-sky-50 text-sky-600"
      aria-hidden="true">
      <app-svg-icon
        src="assets/icons/components/geo-location.svg"
        [size]="18" />
    </span>

    <div class="min-w-0 flex-1">
      <div class="flex items-start justify-between gap-2">
        <div class="min-w-0">
          <p class="text-sm font-semibold text-slate-950">Location details</p>
          <p class="mt-0.5 text-[11px] leading-4 text-slate-500">
            Submitted location
          </p>
        </div>
        <button
          type="button"
          class="rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
          aria-label="Close"
          (click)="close()">
          <app-svg-icon src="assets/icons/close.svg" [size]="16" />
        </button>
      </div>
    </div>
  </div>

  <div class="space-y-3 px-4 pb-4">
    <div
      class="overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
      @if (staticMapUrl(); as mapUrl) {
        <img
          [src]="mapUrl"
          alt="Map preview"
          class="h-36 w-full object-cover" />
      } @else {
        <div
          class="flex h-36 items-center justify-center text-xs text-slate-500">
          Map preview unavailable
        </div>
      }
    </div>

    <div class="space-y-3 rounded-xl border border-slate-200 px-3 py-3">
      <div>
        <p class="text-[11px] font-medium uppercase tracking-wide text-slate-400">
          Display name
        </p>
        <p class="mt-1 text-sm font-medium text-slate-900 break-words">
          {{ displayName }}
        </p>
      </div>

      <div>
        <div class="flex items-center justify-between gap-2">
          <p
            class="text-[11px] font-medium uppercase tracking-wide text-slate-400">
            Full address
          </p>
          <button
            type="button"
            class="rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
            [attr.aria-label]="
              copyFeedback() === 'address' ? 'Copied' : 'Copy address'
            "
            (click)="copyText('address', fullAddress)">
            <app-svg-icon src="assets/icons/content-copy.svg" [size]="14" />
          </button>
        </div>
        <p class="mt-1 text-sm font-medium text-slate-900 break-words">
          {{ fullAddress }}
        </p>
      </div>

      <div class="grid grid-cols-2 gap-3">
        <div>
          <p
            class="text-[11px] font-medium uppercase tracking-wide text-slate-400">
            Latitude
          </p>
          <p class="mt-1 text-sm font-medium text-slate-900">
            {{ formatCoordinate(latitude) }}
          </p>
        </div>
        <div>
          <p
            class="text-[11px] font-medium uppercase tracking-wide text-slate-400">
            Longitude
          </p>
          <p class="mt-1 text-sm font-medium text-slate-900">
            {{ formatCoordinate(longitude) }}
          </p>
        </div>
      </div>

      @if (placeId) {
        <div>
          <div class="flex items-center justify-between gap-2">
            <p
              class="text-[11px] font-medium uppercase tracking-wide text-slate-400">
              Google Place ID
            </p>
            <button
              type="button"
              class="rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
              [attr.aria-label]="
                copyFeedback() === 'placeId' ? 'Copied' : 'Copy place ID'
              "
              (click)="copyText('placeId', placeId)">
              <app-svg-icon src="assets/icons/content-copy.svg" [size]="14" />
            </button>
          </div>
          <p class="mt-1 break-all font-mono text-xs text-slate-700">
            {{ placeId }}
          </p>
        </div>
      }
    </div>

    @if (mapsUrl()) {
      <lib-signal-button
        type="button"
        appearance="primary"
        size="sm"
        [fullWidth]="true"
        postfixIconSrc="assets/icons/open-in-new.svg"
        (clicked)="openInMaps()">
        Open in Google Maps
      </lib-signal-button>
    }
  </div>
</div>
